export const TasksReducerInitialState = {
  tasks: [],
};
